export default function resolveElement(element: HTMLElement | string): HTMLElement {
    let el;

    if (typeof element === 'string') {
        el = document.querySelector<HTMLElement>(element);
    } else if (element instanceof HTMLElement) {
        el = element;
    }

    if (!el) {
        throw TypeError('Could not resolve element for rich text editor');
    }

    return el;
}
